module.exports = __webpack_public_path__ + "fcd71de5.svg";